var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMajesticonsSearchLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.0004 25.0002L19.9379 19.9377M19.9379 19.9377C20.7505 19.1251 21.3951 18.1605 21.8348 17.0989C22.2746 16.0372 22.5009 14.8993 22.5009 13.7502C22.5009 12.6011 22.2746 11.4632 21.8348 10.4016C21.3951 9.3399 20.7505 8.37526 19.9379 7.5627C19.1254 6.75015 18.1607 6.10559 17.0991 5.66584C16.0374 5.22609 14.8996 4.99976 13.7504 4.99976C12.6013 4.99976 11.4634 5.22609 10.4018 5.66584C9.34014 6.10559 8.3755 6.75015 7.56295 7.5627C5.92192 9.20373 5 11.4294 5 13.7502C5 16.071 5.92192 18.2967 7.56295 19.9377C9.20397 21.5787 11.4297 22.5006 13.7504 22.5006C16.0712 22.5006 18.2969 21.5787 19.9379 19.9377Z",
    stroke: "#100C41",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMajesticonsSearchLine);
export default __webpack_public_path__ + "static/media/majesticons_search-line.98f95226c1c7fa31f1d37e19d946d59e.svg";
export { ForwardRef as ReactComponent };